import SidebarBookingsRepliesReplyRoute from 'uplisting-frontend/pods/-sidebar/bookings/replies/reply/route';

export default class ProtectionOverviewBookingsRepliesReplyRoute extends SidebarBookingsRepliesReplyRoute {
  parentRoute = 'protection.overview.bookings';
}
